import type { MenuItem } from '@/types';

/**
 * EdgeAuth docs menu
 */
export const edgeauthDocs: MenuItem[] = [
  { label: 'Overview', path: '/sdk_ref/edgeauth/overview' },
  { label: 'Usage', path: '/sdk_ref/edgeauth/using-edgeauth' },
];
